import React, { useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loading from "../../Components/Common/Loading";
import SEOInputs from "../../Components/PageCard/SEOInputs";
import ProductForm from "../../Components/Products/ProductForm";
import SectionInput from "../../Components/sectioninput/SectionInput";
import { getProductItem } from "../../REDUX/actions/products";
import { updateSection } from "../../REDUX/actions/section";

const ProductItemView = () => {
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch(getProductItem(params.id));
    // eslint-disable-next-line
  }, []);

  const { productItem } = useSelector((state) => state.productsReducer);

  const handleBannerSave = (bannerData, image, image2, image3) => {
    dispatch(
      updateSection(
        {
          title: bannerData.title,
          subtitle: bannerData.subtitle,
          content: bannerData.content,
          description: bannerData.description,
          image: image?.id,
          buttonText: bannerData.buttonText,
          buttonUrl: bannerData.buttonUrl,
          showButton: bannerData.showButton,
        },
        productItem.attributes.banner.data.id,
      ),
    );
  };

  return !productItem && params.id !== "new" ? (
    <Loading />
  ) : (
    <div>
      <Accordion className=" rounded-10 ">
        <SEOInputs
          seo={productItem.attributes.seo?.data}
          title={productItem.attributes.name}
          collapsed
          productId={productItem.id}
        />
        <div className="my-4"></div>
        <SectionInput
          sectionData={{
            ...productItem.attributes.banner.data.attributes,
            image: productItem.attributes.banner.data.attributes.image,
            content:
              productItem.attributes.banner.data.attributes.content || "",
            description:
              productItem.attributes.banner.data.attributes.description || "",
            // image2: productItem.attributes.image2,
            // image3: productItem.attributes.image3,
          }}
          // withSeo
          sectionId={productItem.attributes.banner.data.id}
          titleBlack="Bannière du produit"
          customSaveHandler={handleBannerSave}
          contentLabel="Content"
          titleLabelInput="Nom du produit"
          isProductBanner={true}
        />
        <div className="my-4"></div>
        {/* <SectionInput
          sectionData={productItem.attributes.jetCard.data.attributes}
          sectionId={productItem.attributes.jetCard.data.id}
          fetchProduct={productItem.id}
          titleBlack="Histoire de thérapie"
          noBtn
        /> */}
      </Accordion>
      <ProductForm productItem={productItem} />
    </div>
  );
};

export default ProductItemView;
